export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        ".": ".",
        "...": "...",
        ")": ")",
        ").": ").",
        "@nazwaZmiennej": "@variableName",
        "2 dni": "2 days",
        "2 miesiące": "2 months",
        "2 tygodnie": "2 weeks",
        "3 dni": "3 days",
        "3 miesiące": "3 months",
        "4 dni": "4 days",
        "5 dni": "5 days",
        "6 dni": "6 days",
        "Aby skonfigurować powiadomienie mailowe, należy wybrać": "To configure email notification, select",
        "Adres": "Address",
        "Adres URL": "URL address",
        "Akcent": "Accent",
        "Akceptacja": "Approval",
        "Akceptacja dokumentów": "Document approval",
        "Akceptacja dokumentu": "Document approval",
        "Akceptacja własnych dokumentów": "Approval of own documents",
        "Akceptacja wszystkich dokumentów": "Approval of all documents",
        "Akceptowalny typ plików": "Acceptable file type",
        "Akceptowany format danych": "Acceptable data format",
        "Akceptuj": "Accept",
        "Akcje": "Actions",
        "Akordeon": "Accordion",
        "Aktualizacja definicji": "Definition update",
        "Aktualizacja dokumentu": "Document update",
        "Aktualizacja encji": "Entity update",
        "Aktualizacja wpisu": "Entry update",
        "Aktualizowane pola": "Updated fields",
        "Aktualizuj": "Update",
        "Aktywna": "Active",
        "Aktywne": "Active",
        "Aktywny": "Active",
        "Ankieta": "Survey",
        "Anonimizacja": "Anonymization",
        "Anonimowy": "Anonymous",
        "Anulowany": "Canceled",
        "Anuluj": "Cancel",
        "Aplikacja": "Application",
        "application/json": "application/json",
        "application/x-www-form-urlencoded": "application/x-www-form-urlencoded",
        "Audio": "Audio",
        "Automatyzacja": "Automation",
        "Baza danych": "Database",
        "Bazowy model danych": "Base data model",
        "Bezpieczeństwo": "Security",
        "Bieżący dokument": "Current document",
        "Blok umożliwia mapowanie danych pochodzących z modułu dynamicznego do podanej w wejściu treści tekstu bazowego.": "Block enables mapping data from dynamic module to base text content provided in input.",
        "Blok umożliwia przygotowanie dowolnego skryptu w języku C#.": "Block enables preparing any script in C# language.",
        "Blok wyzwala scenariusz po wykonaniu akcji wybranej w polu": "Block triggers scenario after action selected in field",
        "Blok zwracana model wybranego szablonu wiadomości email.": "Block returns model of selected email message template.",
        "Błąd": "Error",
        "Błędne": "Invalid",
        "Błędny": "Invalid",
        "Błędy walidacji należy przypisać do \"entry.errors.value\" w postaci tablicy komunikatów.": "Validation errors must be assigned to \"entry.errors.value\" as an array of messages.",
        "Bool": "Bool",
        "brak": "none",
        "Brak": "None",
        "Brak danych": "No data",
        "Brak dodanych kolumn": "No columns added",
        "Brak odpowiedzi": "No answer",
        "brak wyboru...": "no selection...",
        "Brak wyników": "No results",
        "Build": "Build",
        "Cache": "Cache",
        "Cache będzie przechowywany z wykorzystaniem serwera Redis.": "Cache will be stored using Redis server.",
        "Cache po stronie serwera": "Server-side cache",
        "Cache-Control": "Cache-Control",
        "Cechy": "Features",
        "Checkbox": "Checkbox",
        "Ciemny": "Dark",
        "Cyfry": "Digits",
        "Czas pomiędzy": "Time between",
        "Czas rozpoczęcia": "Start time",
        "Czas trwania": "Duration",
        "Czas trwania: %0": "Duration: %0",
        "Czas zakończenia": "End time",
        "Cztery kolumny": "Four columns",
        "Czy na pewno chcesz zaktualizować definicje wszystkich dokumentów?": "Are you sure you want to update the definitions of all documents?",
        "Dalej": "Next",
        "Dane": "Data",
        "Dane formularza są przechowywane w obiekcie Entry.": "Form data is stored in the Entry object.",
        "Dane osobowe": "Personal data",
        "Dane tabelaryczne": "Tabular data",
        "Dane z formularza zapisywane anonimowo": "Form data saved anonymously",
        "Data": "Date",
        "Data dodania": "Date added",
        "Data i czas": "Date and time",
        "Data rozpoczęcia": "Start date",
        "Data wywołania": "Call date",
        "Data zakończenia": "End date",
        "Data: %0 | Status: %1": "Date: %0 | Status: %1",
        "DateTime": "DateTime",
        "Dedykowane": "Dedicated",
        "Definicja": "Definition",
        "Definicja (JSON)": "Definition (JSON)",
        "Definicja formularza znajduje się w obiekcie Form.": "Form definition is in the Form object.",
        "Definicje": "Definitions",
        "Definicje zostały zaktualizowane.": "Definitions have been updated.",
        "DELETE: Usunięcie wpisu": "DELETE: Entry deletion",
        "Design Studio": "Design Studio",
        "Diagram": "Diagram",
        "Diagram jest nieprawidłowy, nie zawiera żadnego wyzwalacza.": "Diagram is invalid, it does not contain any trigger.",
        "Diagram jest nieprawidłowy, zawiera więcej niż jeden wyzwalacz.": "Diagram is invalid, it contains more than one trigger.",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" jest elementem dwóch różnych pętli.": "Diagram is invalid. Action \"%0 (%1)\" is part of two different loops.",
        "Diagram jest nieprawidłowy. Akcja \"%0 (%1)\" nie posiada rodzica.": "Diagram is invalid. Action \"%0 (%1)\" does not have parent.",
        "Diagram jest nieprawidłowy. Jedna ze ścieżek zawiera niezgodną liczbę początków i zakończeń pętli.": "Diagram is invalid. One of paths contains mismatched number of loop starts and ends.",
        "Diagram jest nieprawidłowy. Jedna ze ścieżek zawiera zagnieżdżone pętle.": "Diagram is invalid. One of paths contains nested loops.",
        "dla wybranego modelu danych.": "for selected data model.",
        "dla wybranego modułu dynamicznego.": "for selected dynamic module.",
        "Długość czasu przechowywania": "Retention period",
        "Długość geograficzna": "Longitude",
        "do": "to",
        "Do": "To",
        "Dodaj": "Add",
        "Dodaj dni": "Add days",
        "Dodaj dokument": "Add document",
        "Dodaj element": "Add item",
        "Dodaj endpoint": "Add endpoint",
        "Dodaj formularz": "Add form",
        "Dodaj grupę": "Add group",
        "Dodaj kategorię": "Add category",
        "Dodaj komponent": "Add component",
        "Dodaj moduł": "Add module",
        "Dodaj nową wersję dokumentu": "Add new document version",
        "Dodaj obraz": "Add image",
        "Dodaj parametr": "Add parameter",
        "Dodaj podsumowanie": "Add summary",
        "Dodaj pole": "Add field",
        "Dodaj pozycję": "Add position",
        "Dodaj punkt": "Add point",
        "Dodaj scenariusz": "Add scenario",
        "Dodaj sekcję": "Add section",
        "Dodaj stronę": "Add page",
        "Dodaj warunek": "Add condition",
        "Dodaj webhooka": "Add webhook",
        "Dodaj wiersz": "Add row",
        "Dodaj wpis": "Add entry",
        "Dodaj wydarzenie": "Add event",
        "Dodaj źródło": "Add source",
        "Dodane przez": "Added by",
        "Dodanie endpointu": "Adding endpoint",
        "Dodanie komponentu": "Adding component",
        "Dodanie modułu": "Adding module",
        "Dodanie webhooka": "Adding webhook",
        "Dodanie źródła danych": "Adding data source",
        "Dodano za dużo plików (maksymalnie %0).": "Too many files added (maximum %0).",
        "Dodatkowe pola do wyszukiwarki": "Additional fields for search engine",
        "Dodawanie": "Adding",
        "Dodawanie dokumentów": "Adding documents",
        "Dodawanie i edycja własnych dokumentów": "Adding and editing own documents",
        "Dodawanie wartości dwóch kolumn": "Adding values of two columns",
        "Dokument": "Document",
        "Dokument został usunięty.": "Document has been deleted.",
        "Dokumenty": "Documents",
        "Dołączanie plików": "Attaching files",
        "Domyślna wartość": "Default value",
        "Domyślnie ukryte": "Hidden by default",
        "Domyślnie widoczne": "Visible by default",
        "Domyślny": "Default",
        "Dopuść brak odpowiedzi": "Allow no answer",
        "Dostęp do modułu": "Module access",
        "Double": "Double",
        "dowolnej wybranej wersji": "any selected version",
        "Dowolny": "Any",
        "Dozwolone rozszerzenia": "Allowed extensions",
        "Dozwolone rozszerzenia plików": "Allowed file extensions",
        "Dozwolone są tylko małe i duże litery": "Only lowercase and uppercase letters are allowed",
        "Dozwolone są tylko małe litery i znak -": "Only lowercase letters and the - character are allowed",
        "Drugie imię": "Middle name",
        "Duże litery": "Uppercase letters",
        "Duży": "Large",
        "Duży układ siatki": "Large grid layout",
        "Dwie kolumny": "Two columns",
        "Dyrektywa max-age=N wskazuje, że odpowiedź pozostaje świeża do N sekund po wygenerowaniu odpowiedzi.": "The max-age=N directive indicates that the answer remains fresh for N seconds after the answer is generated.",
        "Dyrektywa no-store wskazuje, że jakikolwiek cache dowolnego rodzaju nie powinien przechowywać tej odpowiedzi.": "The no-store directive indicates that any cache of any kind should not store this answer.",
        "Dyrektywa PRIVATE wskazuje, że odpowiedź może być przechowywana wyłącznie w prywatnej pamięci podręcznej (np. lokalnej pamięci przeglądarki).": "Directive PRIVATE indicates that the response may only be stored in private cache (e.g., local browser cache).",
        "Dyrektywa przechowywania": "Storage directive",
        "Dyrektywa PUBLIC wskazuje, że odpowiedź może być przechowywana we współdzielonej pamięci podręcznej (np. proxy).": "Directive PUBLIC indicates that the response may be stored in shared cache (e.g., proxy).",
        "Dyrektywa s-maxage jest ignorowana przez prywatne pamięci podręczne i zastępuje wartość określoną przez dyrektywę max-age dla współdzielonych pamięci podręcznych.": "Directive s-maxage is ignored by private caches and overrides the value specified by the max-age directive for shared caches.",
        "Dyrektywa s-maxage wskazuje, jak długo odpowiedź pozostaje aktualna we współdzielonej pamięci podręcznej (np. proxy).": "Directive s-maxage indicates how long the response remains valid in shared cache (e.g., proxy).",
        "Dyrektywy zakresu": "Range directives",
        "Działania masowe": "Bulk actions",
        "Dzielenie": "Division",
        "dzień": "day",
        "Dzień": "Day",
        "Dzisiaj": "Today",
        "Edycja definicji": "Edit definition",
        "Edycja dokumentów": "Document edit",
        "Edycja dokumentu": "Document edit",
        "Edycja endpointu": "Endpoint edit",
        "Edycja komponentu": "Component edit",
        "Edycja modułu": "Module edit",
        "Edycja scenariusza": "Scenario edit",
        "Edycja w popupie": "Popup edit",
        "Edycja webhooka": "Webhook edit",
        "Edycja wszystkich dokumentów": "Edit all documents",
        "Edycja źródła danych": "Data source edit",
        "Edytor": "Editor",
        "Edytor lokalizowany": "Localized editor",
        "Edytuj": "Edit",
        "Edytuj dokument": "Edit document",
        "Edytuj punkt": "Edit point",
        "Edytuj wiersz": "Edit row",
        "Edytuj wpis": "Edit entry",
        "Edytuj wydarzenie": "Edit event",
        "Eksport do Excela": "Export to Excel",
        "Eksport dokumentów": "Export documents",
        "Element nadrzędny": "Parent item",
        "Element został usunięty": "Item has been deleted",
        "Email": "Email",
        "Endpoint został dodany.": "Endpoint has been added.",
        "Endpoint został zaktualizowany.": "Endpoint has been updated.",
        "Eskportuj": "Export",
        "Etap": "Stage",
        "Etykieta": "Label",
        "Etykiety": "Labels",
        "False": "False",
        "Filmy": "Videos",
        "Filtrowanie": "Filtering",
        "Filtrowanie listy dokumentów": "Document list filtering",
        "Filtry": "Filters",
        "Formularz": "Form",
        "Formularz bazuje na nieaktualnej wersji definicji.": "Form is based on an outdated definition version.",
        "Formularz dynamiczny": "Dynamic form",
        "Formularz jest wymagany": "Form is required",
        "Formularz został dodany.": "Form has been added.",
        "Formularz został skopiowany.": "Form has been copied.",
        "Formularz został utworzony.": "Form has been created.",
        "Formularz został zaakceptowany.": "Form has been approved.",
        "Formularz został zaktualizowany.": "Form has been updated.",
        "Formularze": "Forms",
        "Formuła jest nieprawidłowa": "Formula is invalid",
        "Funkcjonalności": "Functionalities",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "GET: Entry list (sorting and pagination)",
        "GET: Pobranie danych": "GET: Data retrieval",
        "GET: Pobranie wpisu": "GET: Entry retrieval",
        "GET: Schemat (definicja formularza)": "GET: Schema (form definition)",
        "Grafika wektorowa": "Vector graphics",
        "Harmonogram": "Schedule",
        "Hasło": "Password",
        "Hierarchia": "Hierarchy",
        "Hierarchiczny": "Hierarchical",
        "Historia": "History",
        "i obserwując wynik w oknie konsoli.": "and observing result in console window.",
        "Id": "Id",
        "Id dokumentu": "Document ID",
        "Id encji": "Entity ID",
        "ID operacji": "Operation ID",
        "ID procesu": "Process ID",
        "Id wpisu": "Entry ID",
        "Ikona": "Icon",
        "Ikona jest wymagana": "Icon is required",
        "Ilość elementów: %0": "Number of items: %0",
        "Ilość powtórzeń pętli": "Number of loop repetitions",
        "Ilość powtórzeń po wystąpieniu błędu": "Number of retries after error occurrence",
        "Ilość wierszy": "Number of rows",
        "Ilość wyników do odrzucenia": "Number of results to discard",
        "Ilość wyników do pobrania": "Number of results to retrieve",
        "Ilość znaków": "Number of characters",
        "Ilość znaków odpowiedzi": "Number of answer characters",
        "Imię": "First name",
        "Import": "Import",
        "Import modułu": "Module import",
        "Importuj definicję formularza": "Import form definition",
        "Indeksowanie": "Indexing",
        "Info": "Info",
        "Informacja": "Information",
        "input1 < input2": "input1 < input2",
        "Instrukcje": "Instructions",
        "Int": "Int",
        "Jasny": "Light",
        "Jedna kolumna": "One column",
        "JSONPath": "JSONPath",
        "Kafelki": "Tiles",
        "Kalendarz": "Calendar",
        "Kategoria": "Category",
        "Kategoria jest wymagana": "Category is required",
        "Kategoria została dodana.": "Category has been added.",
        "Kategoria została usunięta.": "Category has been deleted.",
        "Kategoria została zaktualizowana.": "Category has been updated.",
        "Kategorie": "Categories",
        "Klucz": "Key",
        "Kod pocztowy": "Postal code",
        "Kod walidacji": "Validation code",
        "Kod źródłowy": "Source code",
        "Kolor": "Color",
        "Kolor ikony": "Icon color",
        "Kolumna": "Column",
        "Kolumny": "Columns",
        "Komponent którego wartość zostanie użyta jako nazwa elementu nadrzędnego. Dostępne tylko komponenty typu ``Tekst``.": "Component whose value will be used as the name of the parent item. Only components of type ``Text`` are available.",
        "Komponent relacyjny": "Relational component",
        "Komponent został dodany.": "Component has been added.",
        "Komponent został usunięty.": "Component has been deleted.",
        "Komponent został zaktualizowany.": "Component has been updated.",
        "Komponent źródłowy": "Source component",
        "Komponenty": "Components",
        "Komunikat błędu": "Error message",
        "Komunikat walidacji": "Validation message",
        "Konfiguracja": "Configuration",
        "Konfiguracja kolumn tabeli": "Table column configuration",
        "Konfiguracja listy": "List configuration",
        "Konfiguracja zaawansowana": "Advanced configuration",
        "Konfiguracja zapytania": "Query configuration",
        "Koniec pętli": "Loop end",
        "Konta użytkowników": "User accounts",
        "Kontrolka": "Control",
        "Kontrolka dostępna publicznie": "Control available publicly",
        "Kontrolka wyboru (pojedynczy wybór, value jest skrótem pobierającym pierwszy element z tablicy data)": "Selection control (single choice, value is a shortcut retrieving the first element from the data array)",
        "Kontrolka wyboru (wybór wielokrotny)": "Selection control (multiple choice)",
        "Konwertuj obrazy do formatu WebP": "Convert images to WebP format",
        "Kopiuj": "Copy",
        "Kopiuj adres": "Copy address",
        "Kopiuj definicję": "Copy definition",
        "Kraj": "Country",
        "Kreator modułu": "Module wizard",
        "Krok minut": "Minute step",
        "Krok minut musi być liczbą z zakresu od 1 do 60.": "Minute step must be a number between 1 and 60.",
        "Kroki": "Steps",
        "Krótki opis": "Short description",
        "Liczba": "Number",
        "Liczba całkowita": "Integer",
        "Liczba dziesiętna": "Decimal number",
        "Liczba wyników na stronie": "Number of results per page",
        "Linia": "Line",
        "linie": "lines",
        "Lista elementów zostanie zawężona tylko do tych, które są pozwiązane z wybranymi wartościami z zaznaczonych komponentów.": "Item list will be narrowed down to those related to selected values from marked components.",
        "Lista ID": "ID list",
        "Lista rozszerzeń oddzielona przecinkami.": "List of extensions separated by commas.",
        "Lista rozwijana": "Dropdown list",
        "Lista sortowalna": "Sortable list",
        "Lista zmiennych do mapowania": "List of variables for mapping",
        "Litery": "Letters",
        "Litery i cyfry": "Letters and digits",
        "Logi": "Logs",
        "Lokalizacja": "Location",
        "Lokalizowane": "Localized",
        "Long": "Long",
        "lub szablonem wiadomości email (blok": "or email message template (block",
        "Łączenie treści": "Content merging",
        "Maksimum": "Maximum",
        "Maksymalna ilość plików": "Maximum number of files",
        "Maksymalna rozdzielość obrazu po optymalizacji: %0x%1px": "Maximum image resolution after optimization: %0x%1px",
        "Maksymalny rozmiar pliku w MB": "Maximum file size in MB",
        "Maksymalny rozmiar pojedynczego pliku": "Maximum single file size",
        "Małe litery": "Lowercase letters",
        "Małe znaki": "Lowercase characters",
        "Mały": "Small",
        "Mały układ siatki": "Small grid layout",
        "Mapa": "Map",
        "Mapowanie danych": "Data mapping",
        "Mapuj swoje zmienne w treści tekstowej do pól formularza": "Map your variables in text content to form fields",
        "Mediana": "Median",
        "Metoda": "Method",
        "Metoda musi zwracać obiekt \"entry.errors\".": "Method must return an \"entry.errors\" object.",
        "Miejsca po przecinku": "Decimal places",
        "Miejscowość": "Locality",
        "miesiąc": "month",
        "Miesiąc": "Month",
        "Minimalna ilość plików": "Minimum number of files",
        "Minimapa": "Minimap",
        "Minimum": "Minimum",
        "Mnożenie": "Multiplication",
        "Model danych": "Data model",
        "Model danych i cechy można skonfigurować tylko podczas dodawania nowego formularza.": "Data model and features can only be configured when adding a new form.",
        "module.": "module.",
        "Moduł": "Module",
        "Moduł będzie skonfigurowany z domyślnymi ustawieniami odpowiednimi do większości zastosowań.": "Module will be configured with default settings suitable for most use cases.",
        "Moduł dynamiczny": "Dynamic module",
        "Moduł został dodany.": "Module has been added.",
        "Moduł został usunięty.": "Module has been deleted.",
        "Moduł został wyeksportowany.": "Module has been exported.",
        "Moduł został zaktualizowany.": "Module has been updated.",
        "Moduły": "Modules",
        "Moduły dynamiczne": "Dynamic modules",
        "Modyfikacja dokumentów": "Document modification",
        "Moje dokumenty": "My documents",
        "Moje punkty": "My points",
        "Moje wydarzenia": "My events",
        "może zostać przekazana z bloku": "can be passed from block",
        "Możliwość wielokrotnego wyboru": "Multiple choice",
        "Multimedia": "Multimedia",
        "multipart/form-data": "multipart/form-data",
        "Na wejściu należy podać dane wejściowe, a następnie zadeklarować": "At input, provide input data, and then declare",
        "Na wyjściu zwracana jest encja wybranego modelu danych.": "At output, entity of selected data model is returned.",
        "Na wyjściu zwracany jest model wpisu wybranego formularza dynamicznego.": "At output, entry model of selected dynamic form is returned.",
        "Nadawanie uprawnień do dokumentów": "Granting privileges to documents",
        "Nadawanie uprawnień do własnych dokumentów": "Granting privileges to own documents",
        "Nadawanie uprawnień do wszystkich dokumentów": "Granting privileges to all documents",
        "Nagłówek": "Header",
        "Nagłówki cache": "Cache headers",
        "należy wybrać z listy pola formularza dynamicznego dla swoich zmiennych z treści bazowej.": "select dynamic form fields for your variables from base content from list.",
        "Następny": "Next",
        "Nazwa": "Name",
        "Nazwa akcji": "Action name",
        "Nazwa etapu": "Stage name",
        "Nazwa formularza": "Form name",
        "Nazwa jest wymagana": "Name is required",
        "Nazwa kategorii": "Category name",
        "Nazwa kolumny": "Column name",
        "Nazwa kolumny z obrazem": "Image column name",
        "Nazwa kolumny z opisem": "Column name with description",
        "Nazwa kolumny z wartością": "Column name with value",
        "Nazwa komponentu": "Component name",
        "Nazwa modelu": "Model name",
        "Nazwa modułu": "Module name",
        "Nazwa musi mieć co najmniej 3 znaki": "Name must have at least 3 characters",
        "Nazwa musi mieć co najmniej 4 znaki": "Name must have at least 4 characters",
        "Nazwa musi mieć co najmniej 5 znaków": "Name must have at least 5 characters",
        "Nazwa nie może być dłuższa niż 30 znaków": "Name cannot exceed 30 characters",
        "Nazwa nie może być dłuższy niż 50 znaków": "Name cannot exceed 50 characters",
        "Nazwa operacji": "Operation name",
        "Nazwa pola jest wymagana": "Field name is required",
        "Nazwa przycisku ``Dalej``": "Button name ``Next``",
        "Nazwa przycisku ``Wstecz``": "Button name ``Back``",
        "Nazwa przycisku ``Wyślij``": "Button name ``Send``",
        "Nazwa scenariusza": "Scenario name",
        "Nazwa sekcji w menu": "Menu section name",
        "Nazwa sekcji...": "Section name...",
        "Nazwa warunku jest wymagana": "Condition name is required",
        "Nazwa warunku musi być unikalna": "Condition name must be unique",
        "Nazwa warunku musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "Condition name must start with lowercase letter and can contain only alphanumeric characters",
        "nazwa warunku...": "condition name...",
        "Nazwa webhooka": "Webhook name",
        "Nazwa wyświetlana": "Display name",
        "Nazwa zmiennej": "Variable name",
        "Nazwa zmiennej jest wymagana": "Variable name is required",
        "Nazwa zmiennej musi być unikalna": "Variable name must be unique",
        "nazwa zmiennej...": "variable name...",
        "Nazwa źródła": "Source name",
        "Nazwa źródła danych": "Data source name",
        "Nazwisko": "Last name",
        "Nazwy wartości": "Value names",
        "Nie": "No",
        "Nie dotyczy plików svg": "Does not apply to svg files",
        "Nie masz dostępu do tego modułu": "You do not have access to this module",
        "Nie masz uprawnień do tego dokumentu": "You do not have privileges to this document",
        "Nie można tworzyć zapętlonych powiązań.": "Cannot create circular references.",
        "Nie można zapisać zmian ponieważ skrypt się nie kompiluje.": "Cannot save changes because the script does not compile.",
        "Nie podano wymaganej ilości znaków: %0.": "Required number of characters not provided: %0.",
        "Nie podano wymaganej ilości znaków: %0. (%1)": "Required number of characters not provided: %0. (%1)",
        "Nie udało się pobrać ustawień kont użytkowników": "Failed to retrieve user account settings",
        "Nie znaleziono formularza.": "No form found.",
        "Nieaktywny": "Inactive",
        "Niepoprawne wyrażenie regularne": "Invalid regular expression",
        "Nieprawidłowa definicja": "Invalid definition",
        "Niestandardowy błąd": "Custom error",
        "Niewidoczne": "Invisible",
        "Nigdy": "Never",
        "no-store (wyłącza cache)": "no-store (disables cache)",
        "Nowa data": "New date",
        "Numer domu": "House number",
        "Numer mieszkania": "Apartment number",
        "Obiekt JSON": "JSON object",
        "Obok siebie": "Side by side",
        "od": "from",
        "Od": "From",
        "od %0": "from %0",
        "Odbiorca": "Recipient",
        "odbiorcę": "recipient",
        "Odejmowanie": "Subtraction",
        "Odpowiedzi": "Answers",
        "Odpowiedzi: %0 na %1": "Answers: %0 out of %1",
        "Odpowiedź dowolna": "Any answer",
        "Odstęp": "Spacing",
        "Omnitool": "Omnitool",
        "Opcje": "Options",
        "Operacje": "Operations",
        "Operacje w pętli": "Operations in loop",
        "Operacje wykonane": "Operations performed",
        "Opis": "Description",
        "Opis błędu": "Error description",
        "Opis źródła": "Source description",
        "Optymalizuj rozdzielczość obrazów": "Optimize image resolution",
        "Ostrzeżenie": "Warning",
        "Parametry wejściowe pochodzą z innych podpiętych bloków.": "Input parameters come from other connected blocks.",
        "Parametry wejściowe skryptu": "Script input parameters",
        "Parametry, wymagane do wykonania zapytania:": "Parameters required to execute the query:",
        "Pasek": "Bar",
        "Pasek postępu": "Progress bar",
        "Pełna kontrola nad wszystkimi ustawieniami modułu oraz endpointami API.": "Full control over all module settings and API endpoints.",
        "Pełny": "Full",
        "Pierwiastkowanie wartości kolumny": "Column value square root",
        "Pigułki": "Pills",
        "Pliki": "Files",
        "Pliki: %0": "Files: %0",
        "po elementach kolekcji": "over collection items",
        "Pobieranie dokumentów": "Document retrieval",
        "Pobieranie encji": "Entity retrieval",
        "Pobieranie i aktualizacja encji": "Entity retrieval and update",
        "Pobieranie i usuwanie encji": "Entity retrieval and deletion",
        "Początek pętli": "Loop start",
        "Początkowa ilość wierszy": "Initial number of rows",
        "Podaj nazwę formularza": "Enter form name",
        "Podaj nazwę scenariusza": "Enter scenario name",
        "Podaj nową nazwę": "Enter new name",
        "Podajemy go w formie jednoliniowej. Przykład:": "Provide it in single-line format. Example:",
        "Podana nazwa jest zajęta.": "Provided name is taken.",
        "Podana wartość jest nieprawidłowa.": "Provided value is invalid.",
        "Podanie nazwy jest wymagane.": "Providing a name is required.",
        "Podano adres": "Address provided",
        "Podano nieprawidłowe dane": "Invalid data provided",
        "Podano nieprawidłowe dane.": "Invalid data provided.",
        "Podano nieprawidłowe dane. (%0)": "Invalid data provided. (%0)",
        "Podgląd": "Preview",
        "Podgląd formularza": "Form preview",
        "Podgląd listy": "List preview",
        "Podgląd tabeli": "Table preview",
        "Podkreślenie": "Underline",
        "Podpis": "Signature",
        "Podproces": "Subprocess",
        "Podstawowe": "Basic",
        "Podstawowe operacje na datach": "Basic date operations",
        "Podstawowe operacje na liczbach": "Basic number operations",
        "Podstawowe operacje tekstowe": "Basic text operations",
        "Podstawowe operacje warunkowe": "Basic conditional operations",
        "Pojedynczy formularz": "Single form",
        "Pojedynczy wybór": "Single choice",
        "Pokaż etykietę": "Show label",
        "Pokaż numery stron": "Show page numbers",
        "Pokaż numery tygodnia na kalendarzu": "Show week numbers on calendar",
        "Pokaż przycisk ``Wyślij``": "Show ``Send`` button",
        "Pokaż tytuł formularza": "Show form title",
        "Pokaż tytuł sekcji": "Show section title",
        "Pokaż tytuł strony": "Show page title",
        "Pokaż tytuły stron": "Show page titles",
        "pokaż więcej...": "show more...",
        "Pola": "Fields",
        "Pole": "Field",
        "Pole \"%0\" jest wymagane.": "Field \"%0\" is required.",
        "Pole \"%0\" jest wymagane. (%1)": "Field \"%0\" is required. (%1)",
        "Pole \"%0\" nie zawiera prawidłowego adresu email.": "Field \"%0\" does not contain a valid email address.",
        "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "Field \"%0\" does not contain a valid URL.",
        "Pole \"%0\" wymaga uzupełnienia wszystkich elementów": "Field \"%0\" requires all elements to be completed",
        "Pole \"%0\" zawiera niedozwoloną wartość.": "Field \"%0\" contains a disallowed value.",
        "Pole \"%0\" zawiera nieprawidłowy symbol.": "Field \"%0\" contains an invalid symbol.",
        "Pole \"Drugie imię\" jest wymagane.": "Field \"Middle name\" is required.",
        "Pole \"Id dokumentu\" jest wymagane.": "Field \"Document ID\" is required.",
        "Pole \"Id encji\" jest wymagane.": "Field \"Entity ID\" is required.",
        "Pole \"Imię\" jest wymagane.": "Field \"First name\" is required.",
        "Pole \"Liczba wyników na stronie\" jest wymagane.": "Field \"Number of results per page\" is required.",
        "Pole \"Model\" jest wymagane.": "Field \"Model\" is required.",
        "Pole \"Moduł dynamiczny\" jest wymagane.": "Field \"Dynamic module\" is required.",
        "Pole \"Moduł\" jest wymagane.": "Field \"Module\" is required.",
        "Pole \"Nazwa modelu\" jest wymagane.": "Field \"Model name\" is required.",
        "Pole \"Nazwisko\" jest wymagane.": "Field \"Last name\" is required.",
        "Pole \"Podproces\" jest wymagane.": "Field \"Subprocess\" is required.",
        "Pole \"Pole\" jest wymagane.": "Field \"Field\" is required.",
        "Pole \"Sekcja modułu\" jest wymagane.": "Field \"Module section\" is required.",
        "Pole \"Sekcja\" jest wymagane.": "Field \"Section\" is required.",
        "Pole \"Typ agregacji\" jest wymagane.": "Field \"Aggregation type\" is required.",
        "Pole \"Tytuł\" jest wymagane.": "Field \"Title\" is required.",
        "Pole jest wymagane": "Field is required",
        "Pole może zawierać jedynie cyfry.": "Field can only contain digits.",
        "Pole może zawierać jedynie cyfry. (%0)": "Field can only contain digits. (%0)",
        "Pole może zawierać jedynie litery i cyfry.": "Field can only contain letters and digits.",
        "Pole może zawierać jedynie litery i cyfry. (%0)": "Field can only contain letters and digits. (%0)",
        "Pole może zawierać jedynie litery.": "Field can only contain letters.",
        "Pole może zawierać jedynie litery. (%0)": "Field can only contain letters. (%0)",
        "Pole może zawierać tylko ciało metody walidującej dane w postaci natywnego kodu JavaScript.": "Field can only contain the body of a data validation method in native JavaScript code.",
        "Pole typu \"%0\" jest niedozwolone w tym formularzu.": "Field type \"%0\" is not allowed in this form.",
        "Pole wymaga podania przynajmniej jednego znaku specjalnego.": "Field requires at least one special character.",
        "Pole wymaga podania przynajmniej jednej cyfry.": "Field requires at least one digit.",
        "Pole wymaga podania przynajmniej jednej dużej litery.": "Field requires at least one uppercase letter.",
        "Pole wymaga podania przynajmniej jednej małej litery.": "Field requires at least one lowercase letter.",
        "Pole wymagane": "Required field",
        "Pole zawiera": "Field contains",
        "Pomoc": "Help",
        "Poprawne": "Correct",
        "Poprawność kompilacji skryptu można przetestować, wciskając przycisk": "Script compilation correctness can be tested by pressing button",
        "Poprawny": "Valid",
        "Poprzedni": "Previous",
        "Porównaj %0": "Compare %0",
        "Porównania": "Comparisons",
        "Porównanie": "Comparison",
        "Porównywana wersja": "Compared version",
        "POST: Dowolne wyszukiwanie (Zapytanie EQL)": "POST: Any search (EQL Query)",
        "POST: Upload załączników": "POST: Upload attachments",
        "POST: Utworzenie wpisu": "POST: Create entry",
        "POST: Zapisanie zmian": "POST: Save changes",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Potwierdź akceptację": "Confirm approval",
        "Potwierdź usunięcie": "Confirm deletion",
        "Powiadomienie mailowe": "Email notification",
        "Powiązana kontrolka": "Linked control",
        "Powiększ": "Enlarge",
        "Powinno się dodać dyrektywę PRIVATE dla treści personalizowanych dla użytkownika, zwłaszcza dla odpowiedzi otrzymywanych po zalogowaniu i z uwzględnieniem uprawnień.": "PRIVATE directive should be added for user-personalized content, especially for responses received after login and considering privileges.",
        "Powrót": "Back",
        "Powtórzenia": "Repetitions",
        "Powyższe obiekty zawierają tylko właściwości i są pozbawione wszystkich metod.": "The above objects contain only properties and lack all methods.",
        "Poziom dostępu do webhooka": "Webhook access level",
        "Poziom dostępu użytkownika": "User access level",
        "pozwala na wykorzystanie zaawansowanego edytora tekstu.": "enables using advanced text editor.",
        "Pozwól na dodawanie wierszy": "Allow adding rows",
        "Pozwól na sortowanie wierszy": "Allow sorting rows",
        "Pozycja na liście": "Position on list",
        "Pozycje zostały zapisane.": "Positions have been saved.",
        "pół roku": "half a year",
        "Prezentacja": "Presentation",
        "private (tylko cache przeglądarki)": "private (browser cache only)",
        "Procent": "Percent",
        "Proces": "Process",
        "Projekt": "Project",
        "Proste uprawnienia": "Simple privileges",
        "Przedrostek": "Prefix",
        "Przejdź do kolejnego kroku gdy:": "Proceed to the next step when:",
        "Przekroczono dozwoloną ilość znaków: %0.": "Exceeded allowed number of characters: %0.",
        "Przekroczono dozwoloną ilość znaków: %0. (%1)": "Exceeded allowed number of characters: %0. (%1)",
        "Przełącznik": "Switch",
        "Przeniesienie wpisu do kosza": "Move entry to bin",
        "Przenieś niżej": "Move down",
        "Przenieś wyżej": "Move up",
        "Przerwany": "Interrupted",
        "Przesuń do góry": "Move up",
        "Przesuń na dół": "Move down",
        "Przybliżenie": "Zoom",
        "Przybornik": "Toolkit",
        "Przykład:": "Example:",
        "Przykładowa struktura danych": "Sample data structure",
        "Przykłady": "Examples",
        "Przykłady konfiguracji": "Configuration examples",
        "przypisz wynik etapu...": "assign stage result...",
        "Przyrostek": "Suffix",
        "Przywrócenie wpisu z kosza": "Restore entry from bin",
        "public (cache przeglądarki i proxy)": "public (browser and proxy cache)",
        "PUT: Aktualizacja wpisu": "PUT: Update entry",
        "Pytania": "Questions",
        "Query string": "Query string",
        "Radio": "Radio",
        "Relacyjne": "Relational",
        "Request body": "Request body",
        "Rest API": "Rest API",
        "RESTful API": "RESTful API",
        "Rezultat": "Result",
        "Rodzaj odpowiedzi": "Response type",
        "Rodzaj pętli": "Loop type",
        "rok": "year",
        "Rok": "Year",
        "Rozmiar okna popup": "Popup window size",
        "Rozmiar podawany w bajtach.": "Size provided in bytes.",
        "Rozmieść równomiernie": "Distribute evenly",
        "Równość": "Equality",
        "Satysfakcja": "Satisfaction",
        "Scenariusz": "Scenario",
        "Scenariusz aktywny": "Active scenario",
        "Scenariusz jest aktywowany po wywołaniu wybranego Webhooka.": "Scenario is activated after selected Webhook is called.",
        "Scenariusz jest aktywowany według wybranego hamonogramu.": "Scenario is activated according to selected schedule.",
        "Scenariusz został dodany.": "Scenario has been added.",
        "Scenariusz został usunięty.": "Scenario has been deleted.",
        "Scenariusz został utworzony.": "Scenario has been created.",
        "Scenariusz został zaktualizowany.": "Scenario has been updated.",
        "Scrollowalne okna popup": "Scrollable popup windows",
        "Sekcja": "Section",
        "Sekcja modułu": "Module section",
        "Selektor ikony": "Icon selector",
        "Selektor kolorów": "Color selector",
        "Server Side Cache": "Server Side Cache",
        "Skala 1-5": "Scale 1-5",
        "Skrypt (C#)": "Script (C#)",
        "słowa": "words",
        "Słownik": "Dictionary",
        "Specjalizowane": "Specialized",
        "Specyfikacja": "Specification",
        "Sposób prezentacji zakładek": "Tab presentation method",
        "Sprawdzenie czy pusty": "Check if empty",
        "Stała wartość": "Constant value",
        "Stan": "State",
        "Standardowe uprawnienia": "Standard privileges",
        "Standardowy": "Standard",
        "Start": "Start",
        "Status": "Status",
        "Status dokumentu został zmieniony.": "Document status has been changed.",
        "Status modułu": "Module status",
        "Status webhooka": "Webhook status",
        "Status żądania": "Request status",
        "string": "string",
        "String": "String",
        "Strona": "Page",
        "Strona %0": "Page %0",
        "Studio": "Studio",
        "Stwierdzenie": "Statement",
        "Styl": "Style",
        "Sukces": "Success",
        "Suma": "Sum",
        "Switch": "Switch",
        "Symbol": "Symbol",
        "Symbol jest wymagany": "Symbol is required",
        "Symbol jest zajęty": "Symbol is taken",
        "Symbol modułu": "Module symbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "Symbol can only consist of lowercase letters, digits, and the - character",
        "Symbol musi mieć co najmniej 3 znaki": "Symbol must have at least 3 characters",
        "Symbol musi mieć co najmniej 4 znaki": "Symbol must have at least 4 characters",
        "Symbol musi mieć co najmniej 5 znaków": "Symbol must have at least 5 characters",
        "Symbol nie może być dłuższy niż 10 znaków": "Symbol cannot exceed 10 characters",
        "Symbol nie może być dłuższy niż 20 znaków": "Symbol cannot exceed 20 characters",
        "Symbol w adresie URL": "Symbol in URL",
        "Synchronizuj": "Synchronize",
        "System": "System",
        "Szablon modułu": "Module template",
        "Szablon wiadomości email": "Email message template",
        "Szablony definiowane są w ": "Templates are defined in ",
        "Szablony te definiowane są w ": "These templates are defined in ",
        "Szczegóły": "Details",
        "Szerokość geograficzna": "Latitude",
        "Ścieżka": "Path",
        "Ścieżka zmiennej w formie JSONPath": "Variable path in JSONPath format",
        "Średni": "Average",
        "Średnia": "Average",
        "Tabela": "Table",
        "Tak": "Yes",
        "Tak/Nie": "Yes/No",
        "Tekst": "Text",
        "Tekst lokalizowany": "Localized text",
        "Tekst zastępczy": "Placeholder text",
        "Telefon": "Phone",
        "Teraz": "Now",
        "Test": "Test",
        "Testuj zapytanie": "Test query",
        "Transformata": "Transform",
        "Treści odpowiedzi są wymagane": "Response content is required",
        "Treści pytań są wymagane": "Question content is required",
        "Treść": "Content",
        "Treść bazowa musi zawierać zmienne, które należy zadeklarować według wzoru:": "Base content must contain variables that should be declared according to pattern:",
        "Treść taka może być zmienną tekstową (blok": "Such content can be text variable (block",
        "Treść tekstu bazowego": "Base text content",
        "Treść wiadomości email": "Email message content",
        "True": "True",
        "Tryb prezentacyjny": "Presentation mode",
        "Trzy kolumny": "Three columns",
        "Tworzenie dokumentów": "Document creation",
        "Tworzenie dokumentu": "Document creation",
        "Tworzenie encji": "Entity creation",
        "tydzień": "week",
        "Tydzień": "Week",
        "Tylko do odczytu": "Read-only",
        "Typ agregacji": "Aggregation type",
        "Typ kontentu": "Content type",
        "Typ pola": "Field type",
        "Typ zmiennej": "Variable type",
        "typu tekstowego lub w postaci szablonu z bloku": "of text type or as template from block",
        "Tytuł": "Title",
        "Tytuł formularza jest wymagany": "Form title is required",
        "Tytuł formularza nie może być dłuższy niż %0 znaków": "Form title cannot exceed %0 characters",
        "Tytuł maila": "Email subject",
        "Tytuł sekcji": "Section title",
        "tytułu": "title",
        "Układ": "Layout",
        "Ukryta": "Hidden",
        "Ukryty": "Hidden",
        "Ulica": "Street",
        "Uprawnienia": "Privileges",
        "Uprawnienia do dokumentów": "Document privileges",
        "Url": "Url",
        "Uruchomienie procesu": "Process start",
        "Ustaw szerokości proporcjonalnie": "Set proportional widths",
        "Ustawienia": "Settings",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Usunięcie dokumentu": "Document removal",
        "Usunięcie formularzannOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!nCzy na pewno chcesz usunąć wybrany formularz?": "Form deletionnOperation is irreversible. All related documents will be lost!nAre you sure you want to delete selected form?",
        "Usunięcie wpisu": "Entry removal",
        "Usuń": "Delete",
        "Usuń dokument": "Delete document",
        "Usuń grupę": "Delete group",
        "Usuń logi gdy wykonywanie scenariusza": "Delete logs when executing scenario",
        "Usuń parametr": "Delete parameter",
        "Usuń pole": "Delete field",
        "Usuń pozycję": "Delete item",
        "Usuń punkt": "Delete point",
        "Usuń sekcję": "Delete section",
        "Usuń spacje": "Delete spaces",
        "Usuń warunek": "Delete condition",
        "Usuń wydarzenie": "Delete event",
        "Usuwanie dokumentów": "Document deletion",
        "Usuwanie encji": "Entity deletion",
        "Usuwanie własnych dokumentów": "Deleting own documents",
        "Usuwanie wszystkich dokumentów": "Deleting all documents",
        "Utworzenie wpisu": "Entry creation",
        "Utwórz formularz": "Create form",
        "Utwórz kopię formularza": "Create form copy",
        "Utwórz kopię z": "Create copy from",
        "Utwórz scenariusz": "Create scenario",
        "UWAGA: Brak obsługi TypeScript oraz w kodzie metody nie można robić importów.": "WARNING: No TypeScript support and method code cannot include imports.",
        "Użyj domyślnego zapytania SQL": "Use default SQL query",
        "W bloku zmiennej możliwe jest zdefiniowanie wartości dla jednego z podstawowych typów danych, do wykorzystania w dalszej części procesu.": "In variable block, it is possible to define value for one of basic data types, to use in further part of process.",
        "W ciele metody walidującej dostępne są poniższe zmienne:": "The following variables are available in the validation method body:",
        "W przypadku zmiennych zagnieżdżonych należy wykorzystać opcję": "For nested variables, use option",
        "W przyszłości": "In the future",
        "w wyznaczonym zakresie": "within specified range",
        "W zakładce": "In tab",
        "Walidacja": "Validation",
        "Walidacja danych": "Data validation",
        "Walidacja po stronie API": "API-side validation",
        "Walidacja typów MIME": "MIME type validation",
        "Wartośc pola jest wymagana": "Field value is required",
        "Wartość domyślna": "Default value",
        "Wartość warunku jest wymagana": "Condition value is required",
        "Wartość zmiennej": "Variable value",
        "Warunek": "Condition",
        "Warunek jest zdefiniowany przy użyciu wyrażenia lambda w C#. Przykład:": "Condition is defined using lambda expression in C#. Example:",
        "Warunek nie zostanie spełniony": "Condition will not be met",
        "Warunek zostanie spełniony": "Condition will be met",
        "Warunki": "Conditions",
        "Warunki logiczne": "Logical conditions",
        "Warunkowo": "Conditionally",
        "Ważność": "Validity",
        "Webhook": "Webhook",
        "Webhook został dodany.": "Webhook has been added.",
        "Webhook został usunięty.": "Webhook has been deleted.",
        "Webhook został zaktualizowany.": "Webhook has been updated.",
        "Webhooki": "Webhooks",
        "Wersje": "Versions",
        "wersji zaakceptowanej": "accepted version",
        "Wersjonowany": "Versioned",
        "Wewnętrznie": "Internally",
        "wiadomosci.": "message.",
        "Widoczność": "Visibility",
        "Widoczność modułu w menu": "Module visibility in menu",
        "Widoczność sekcji w menu modułu": "Section visibility in module menu",
        "Wielkość kroku": "Step size",
        "Wielokrotny wybór": "Multiple choice",
        "Wiersz": "Row",
        "więcej...": "more...",
        "Więcej...": "More...",
        "Wklej komponent": "Paste component",
        "Właściwości": "Properties",
        "Właściwości szablonu": "Template properties",
        "Włącz": "Enable",
        "Włącz tryb zaawansowany": "Enable advanced mode",
        "Włącz walidację po stronie API": "Enable API-side validation",
        "Włącza bardzo restrykcyjne sprawdzanie typów MIME dla wysyłanych plików. W przypadku zgłaszania błędów dla plików, których zawartości jesteśmy pewni, należy tą opcję pozostawić nieaktywną.": "Enables very strict MIME type checking for uploaded files. If errors are reported for files whose content is certain, this option should remain inactive.",
        "Włączone": "Enabled",
        "Województwo": "Province",
        "Wpis został dodany.": "Entry has been added.",
        "Wpis został usunięty": "Entry has been deleted",
        "Wpis został usunięty.": "Entry has been deleted.",
        "Wpis został zaakceptowany.": "Entry has been accepted.",
        "Wpis został zaktualizowany.": "Entry has been updated.",
        "Wpisz adres e-mail ręcznie": "Enter email address manually",
        "Wskazuje, jak długo odpowiedź pozostaje aktualna w pamięci serwera Redis.": "Indicates how long the answer remains valid in Redis server memory.",
        "Wstaw kontrolkę": "Insert control",
        "Wstaw stronę": "Insert page",
        "Wstaw z dołu": "Insert from bottom",
        "Wstaw z góry": "Insert from top",
        "Wstaw z lewej strony": "Insert from left side",
        "Wstaw z prawej strony": "Insert from right side",
        "Wstecz": "Back",
        "Wstępne filtrowanie danych": "Preliminary data filtering",
        "Wszystkie": "All",
        "Wybie22rz moduł, aby dodać sekcję, lub pozostaw pole puste, aby utworzyć nowy moduł": "Select module to add section, or leave field empty to create new module",
        "Wybierz formularz zawierający dodatkowe pola dla kont użytkownków": "Select form containing additional fields for user accounts",
        "wybierz...": "select...",
        "Wybór": "Choice",
        "Wybór+": "Choice+",
        "Wybrana data jest mniejsza niż dozwolona %0.": "Selected date is less than allowed %0.",
        "Wybrana data jest większa niż dozwolona %0.": "Selected date is greater than allowed %0.",
        "Wybrana liczba jest mniejsza niż dozwolona %0.": "Selected number is less than allowed %0.",
        "Wybrana liczba jest większa niż dozwolona %0.": "Selected number is greater than allowed %0.",
        "Wybrane dokumenty": "Selected documents",
        "Wybrane: %0": "Selected: %0",
        "Wybranie przynajmniej jednego pola do aktualizacji jest wymagane.": "Selecting at least one field to update is required.",
        "Wybranie przynajmniej jednego warunku jest wymagane.": "Selecting at least one condition is required.",
        "Wyczyść": "Clear",
        "Wykonuje się": "Executing",
        "Wyłączone": "Disabled",
        "Wymaga autoryzacji": "Requires authorization",
        "Wymagane jest wybranie formularza": "Selecting form is required",
        "Wymagane jest wybranie kategorii": "Selecting category is required",
        "Wymagane jest wybranie komponentu": "Selecting component is required",
        "Wymagane jest wybranie modułu": "Selecting module is required",
        "Wymagane jest wybranie sekcji": "Selecting section is required",
        "Wymagane jest wybranie źródła": "Selecting source is required",
        "Wymagane jest wybranie źródła danych": "Selecting data source is required",
        "Wymagane znaki": "Required characters",
        "Wynik": "Result",
        "Wynik etapu jest wymagany": "Stage result is required",
        "Wynik testu": "Test result",
        "Wyniki testu zawszę będą ograniczone do maksymalnie 10 pozycji.": "Test results will always be limited to a maximum of 10 items.",
        "Wyrażenia warunkowe": "Conditional expressions",
        "Wyrażenie regularne": "Regular expression",
        "Wyrażenie w postaci \"/pattern/flag\" nie jest obsługiwane, użyj same wartości pattern": "Expression in form \"/pattern/flag\" is not supported, use pattern value only",
        "Wystąpił błąd podczas próby importu definicji modułu.": "Error occurred during module definition import attempt.",
        "Wyszukiwany ciąg znaków": "Search string",
        "Wyślij": "Send",
        "Wyświetlanie dokumentów": "Document display",
        "Wytnij": "Cut",
        "Wyzwalacze": "Triggers",
        "Wzorzec": "Pattern",
        "z listy uzytkowników lub wpisać adres e-mail ręcznie. Wymagane jest również podanie": "from user list or enter email address manually. Providing",
        "Z uprawnieniami": "With privileges",
        "Z uprawnieniami do modułu": "With module privileges",
        "Zaawansowane uprawnienia": "Advanced privileges",
        "Zaawansowany edytor tekstu": "Advanced text editor",
        "Zachowaj oryginalny format obrazów": "Preserve original image format",
        "zacznij pisać aby wyszukać szablon...": "start typing to search template...",
        "zacznij pisać aby wyszukać użytkownika...": "start typing to search user...",
        "Zacznij pisać Form lub Entry aby uruchomić podpowiadanie.": "Start typing Form or Entry to trigger suggestions.",
        "Zaczyna sie od": "Starts with",
        "Zagrożenie": "Threat",
        "Zaimportowano definicję modułu.": "Module definition has been imported.",
        "Zakładki": "Bookmarks",
        "Zakończ edycje": "Finish edit",
        "Zakończony": "Finished",
        "zakończy się porażką": "will end in failure",
        "zakończy się sukcesem": "will end successfully",
        "Zakres": "Range",
        "Zakres czasu": "Time range",
        "Zaktualizuj formularz": "Update form",
        "Zaktualizuj najnowszą wersję dokumentu": "Update latest document version",
        "Zależna od kontrolki": "Dependent on control",
        "Zalogowany": "Logged in",
        "Załączniki": "Attachments",
        "Zamknij": "Close",
        "Zaokrąglenie": "Rounding",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and back",
        "Zapisz i zamknij": "Save and close",
        "Zapisz kategorię": "Save category",
        "Zapisz pozycje": "Save positions",
        "Zapisz zmiany": "Save changes",
        "Zapytanie SQL do pobrania po ID": "SQL query to fetch by ID",
        "Zapytanie SQL do wyszukiwania": "SQL query for search",
        "Zasięg": "Range",
        "Zawiera": "Contains",
        "Zawsze": "Always",
        "Zdjęcia": "Photos",
        "Zdjęcie": "Photo",
        "Zgoda": "Consent",
        "Zliczanie": "Counting",
        "Zmiany zostały zapisane.": "Changes have been saved.",
        "Zmienna": "Variable",
        "Zmienna musi być typu string": "Variable must be of type string",
        "Zmienna musi odwoływać się do formularza dynamicznego": "Variable must refer to dynamic form",
        "Zmienna musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "Variable must start with lowercase letter and can contain only alphanumeric characters",
        "Zmienna tego typu, to np. tabela.": "Variable of this type is, for example, table.",
        "Zmienne": "Variables",
        "Zmniejsz": "Reduce",
        "znaki": "characters",
        "Znaki specialne": "Special characters",
        "Zostaną zaktualizowane definicje wszystkich dokumentów.": "Definitions of all documents will be updated.",
        "Źródła danych": "Data sources",
        "Źródło danych": "Data source",
        "źródło danych zostało dodane.": "data source has been added.",
        "Źródło danych zostało zaktualizowane.": "Data source has been updated.",
        "źródło zostało usunięte.": "source has been deleted.",
        "Żródło danych": "Data source"
    }
};
